module.exports = __webpack_public_path__ + "static/media/lexus-thumbs.08bef9d9.svg";